export default function Council2017Entries() {
  return (
    <table id="filetable">
      {/*Start Table*/}
      <tr>
        <th>Meeting Date</th>
        <th>Minutes</th>
        <th>Agenda</th>
      </tr>
      {/*Start File*/}
      <tr>
        <td>12-18-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-12-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}

      {/*Start File*/}
      <tr>
        <td>12-12-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-12-12-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}

      {/*Start File*/}
      <tr>
        <td>11-29-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-11-29-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>11-28-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-11-28-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>11-27-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-11-27-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>11-20-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-11-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>11-14-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-11-14-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>10-16-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-10-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>10-05-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-10-05-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>09-18-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-09-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>08-08-2016</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-08-08-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>07-17-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-07-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>07-11-2016</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-07-11-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>06-19-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-06-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*End File*/}
      <tr>
        <td>06-13-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-06-13-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*End File*/}
      <tr>
        <td>05-23-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-05-23-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*End File*/}
      <tr>
        <td>04-11-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-04-11-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*End File*/}
      <tr>
        <td>03-20-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-03-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*End File*/}
      <tr>
        <td>02-21-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-02-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*End File*/}
      <tr>
        <td>02-14-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-02-14-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*End File*/}
      <tr>
        <td>01-17-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-01-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      {/*End File*/}
      <tr>
        <td>01-10-2017</td>
        <td>
          <a href="../docs/council/minutes/2017/2017-01-10-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
    </table>
  );
}
